// frontend/src/api/settings.js
import { apiClient } from './index';

const settingsApi = {
  /**
   * Get all system settings (Pricing, AI, etc.)
   */
  getAllSettings: async () => {
    return await apiClient.get('/settings/');
  },

  /**
   * Public: active bank accounts + support contacts for pay-by-transfer.
   */
  getPaymentInfo: async () => {
    return await apiClient.get('/settings/payment-info');
  },

  /**
   * Update a specific settings category
   * @param {string} category - 'pricing', 'ai_config', 'site_content', 'pages_content', 'banner_config', 'premium_config'
   * @param {Object} data - The new settings object
   */
  updateSettings: async (category, data) => {
    try {
        return await apiClient.put(`/settings/${category}`, data);
    } catch (error) {
        console.error(`[settingsApi] Failed to update ${category}:`, error);
        const errorMessage = error.data?.message || error.message || `Unknown error updating ${category}.`;
        throw new Error(errorMessage);
    }
  },

  /**
   * Reset a specific settings category to default
   * @param {string} category 
   */
  resetSettings: async (category) => {
      return await apiClient.post(`/settings/${category}/reset`, {});
  },
  
  // --- SITE CONTENT API ---
  getSiteContent: async () => {
      return await apiClient.get('/site-content/');
  },

  updateSiteContent: async (data) => {
      return await apiClient.put('/site-content/', data);
  },

  // --- BANNER API ---
  getBanner: async () => {
      return await apiClient.get('/settings/banner');
  },

  updateBanner: async (data) => {
      return await apiClient.put('/settings/banner', data);
  }
};

export { settingsApi };